import React from "react";
import { Title } from "../../components/Title";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const BuildIdaasService = () => {
  const { t } = useTranslation();
  return (
    <div className="build-idaas-service">
      <section>
        <div className="inner">
          <Title title={t("solution.buildIdaas.service.title")}>{t("solution.buildIdaas.service.subtitle")}</Title>
          <div className="service-warp">
            <div className="title">{t("solution.buildIdaas.service.descript.title")}</div>
            <div className="item">
              <span className="order first-order">01</span>
              <span className="text">{t("solution.buildIdaas.service.descript.item1")}</span>
            </div>
            <div className="item">
              <span className="order second-order">02</span>
              <span className="text">{t("solution.buildIdaas.service.descript.item2")}</span>
            </div>
            <div className="item">
              <span className="order third-order">03</span>
              <span className="text">{t("solution.buildIdaas.service.descript.item3")}</span>
            </div>
          </div>
          <Title title={t("solution.buildIdaas.service.services.title")} size="h2"></Title>
          <div className="service-item">
            <div className="item-text">
              <div className="title">{t("solution.buildIdaas.service.services.item1.title")}</div>
              <div className="descript">{t("solution.buildIdaas.service.services.item1.descript")}</div>
            </div>
            <div>
              <div className="item-img">
                <img
                  src="//files.authing.co/authing-website/solution-build-idaas-dashbord.png"
                  alt="authing idaas dashbord"
                />
              </div>
              <div className="img-text">{t("solution.buildIdaas.service.services.item1.imgText")}</div>
            </div>
          </div>

          <div className="service-item">
            <div>
              <div className="item-img">
                <img
                  src="//files.authing.co/authing-website/solution-build-idaas-pipeline.png"
                  alt="authing idaas pipeline"
                />
              </div>
              <div className="img-text">{t("solution.buildIdaas.service.services.item2.imgText")}</div>
            </div>
            <div className="item-text">
              <div className="title">{t("solution.buildIdaas.service.services.item2.title")}</div>
              <div className="descript">{t("solution.buildIdaas.service.services.item2.descript")}</div>
            </div>
          </div>

          <div className="service-item">
            <div className="item-text">
              <div className="title">{t("solution.buildIdaas.service.services.item3.title")}</div>
              <div className="descript">{t("solution.buildIdaas.service.services.item3.descript")}</div>
            </div>
            <div>
              <div className="item-img">
                <img
                  src="//files.authing.co/authing-website/solution-build-idaas-tenant.png"
                  alt="authing idaas tenant"
                />
              </div>
              <div className="img-text">{t("solution.buildIdaas.service.services.item3.imgText")}</div>
            </div>
          </div>
          <div className="service-item">
            <div>
              <div className="item-img">
                <img
                  src="//files.authing.co/authing-website/solution-build-idaas-setting.png"
                  alt="authing idaas setting"
                />
              </div>
              <div className="img-text">{t("solution.buildIdaas.service.services.item4.imgText")}</div>
            </div>
            <div className="item-text">
              <div className="title">{t("solution.buildIdaas.service.services.item4.title")}</div>
              <div className="descript">{t("solution.buildIdaas.service.services.item4.descript")}</div>
            </div>
          </div>
          <div className="service-item">
            <div className="item-text">
              <div className="title">{t("solution.buildIdaas.service.services.item5.title")}</div>
              <div className="descript">{t("solution.buildIdaas.service.services.item5.descript")}</div>
            </div>
            <div>
              <div className="item-img">
                <img src="//files.authing.co/authing-website/solution-build-idaas-sdk.png" alt="authing idaas sdk" />
              </div>
              <div className="img-text">{t("solution.buildIdaas.service.services.item5.imgText")}</div>
            </div>
          </div>
          <div className="service-extra">{t("solution.buildIdaas.service.services.extra")}</div>
        </div>
      </section>
    </div>
  );
};
